import { render, staticRenderFns } from "./PlainDetail.vue?vue&type=template&id=137e7624&scoped=true&"
import script from "./PlainDetail.vue?vue&type=script&lang=js&"
export * from "./PlainDetail.vue?vue&type=script&lang=js&"
import style0 from "./PlainDetail.vue?vue&type=style&index=0&id=137e7624&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137e7624",
  null
  
)

export default component.exports